<div class="reset-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="reset-card incorrect-card">
    <!-- Icon (same style as expired: warning in circle) -->
    <div class="incorrect-icon-wrap">
      <i class="ph ph-warning incorrect-icon" aria-hidden="true"></i>
    </div>

    <!-- Text block: title + paragraphs (gap 12px, centered) -->
    <div class="incorrect-text-block">
      <h2 class="incorrect-heading">{{ 'reset-password.title-incorrect' | translate }}</h2>
      <p class="incorrect-line">{{ 'reset-password.sub-title-incorrect' | translate }}</p>
      <p class="incorrect-line">{{ 'reset-password.sub-title-incorrect-l2' | translate }}</p>
      <p class="incorrect-line">{{ 'reset-password.sub-title-incorrect-l3' | translate }}</p>
      <p class="incorrect-line">{{ 'reset-password.sub-title-incorrect-l4' | translate }}</p>
      <p class="incorrect-line">{{ 'reset-password.sub-title-incorrect-l5' | translate }}</p>
    </div>

    <!-- Actions: CTA + back link -->
    <div class="incorrect-actions">
      <a [routerLink]="['/login/forgot-password']" class="btn-incorrect-cta" data-cy="reset-password-incorrect-new-reset-link">
        <i class="ph ph-envelope btn-cta-icon" aria-hidden="true"></i>
        <span>{{ 'reset-password.new-reset' | translate }}</span>
      </a>
      <a [routerLink]="['/login']" class="link-back" data-cy="reset-password-incorrect-back-link">
        {{ 'reset-password.back-to-login' | translate }}
      </a>
    </div>
  </div>
</div>
